module.exports = __webpack_public_path__ + "img/artboard2.06fb9038.png";